'use strict';
import Select from "./search/filter/Select";
import SpinWidget from "./SpinWidget";

export default function OfferDetailForm({ departDate = null, departDateFrom = null, departDateTo = null, maxSeats = 10, errors = {}, formDataInit = {}, onChange }) {

    const [dateList, setDateList] = React.useState([]);
    const [timeList, setTimeList] = React.useState([]);
    const [dateValue, setDateValue] = React.useState('');
    const [timeValue, setTimeValue] = React.useState('12:00');
    const [seatsValue, setSeatsValue] = React.useState(1);

    const handleDateChange = (value) => {
        setDateValue(() => value);
    };
    const handleTimeChange = (value) => {
        setTimeValue(value);
    };
    const handleSeatsChange = (value) => {
        setSeatsValue(value);
    };
    const handleChangeValue = () => {
        onChange && onChange({
            date: dateValue,
            time: timeValue,
            seats: seatsValue,
        });
    };

    React.useEffect(() => {
        handleChangeValue();
    }, [dateValue, timeValue, seatsValue]);

    const getValue = (moment) => {
        return moment.format('DD.MM.YYYY');
    };
    const getTitle = (moment) => {
        return moment.format('DD.MM.YYYY');
    };

    React.useEffect(() => {
        // ДАТЫ

        const dateList = [];

        const depart_moment = departDate ? moment(departDate, 'DD.MM.YYYY') : null;
        const depart_from_moment = departDateFrom ? moment(departDateFrom, 'DD.MM.YYYY') : null;
        let depart_to_moment = departDateTo ? moment(departDateTo, 'DD.MM.YYYY') : null;

        if (depart_from_moment && depart_from_moment.isValid() && depart_to_moment && depart_to_moment.isValid()) {

            const now = moment().startOf('day');
            const depart_from_moment_actual = depart_from_moment.startOf('day').isBefore(now) ? now : depart_from_moment;

            if (depart_to_moment.startOf('day').isBefore(depart_from_moment_actual.startOf('day'))) {
                depart_to_moment = depart_from_moment_actual;
                console.error('Неверный диапазон');
            }

            handleDateChange(getTitle(depart_from_moment_actual));

            while (depart_from_moment_actual.isSameOrBefore(depart_to_moment.startOf('day'))) {
                dateList.push({
                    id: getValue(depart_from_moment_actual),
                    title: getTitle(depart_from_moment_actual)
                });
                depart_from_moment_actual.add(1, 'days');
            }

        } else if (depart_moment && depart_moment.isValid()) {

            handleDateChange(getTitle(depart_moment));
            dateList.push({
                id: getValue(depart_moment),
                title: getTitle(depart_moment)
            });

        }

        setDateList(dateList);


        // ВРЕМЯ
        const timeList = Array.from({ length: 48 }, (_, i) => {
            const hh = String(Math.floor(i / 2)).padStart(2, '0');
            const mm = (i % 2 === 0) ? '00' : '30';
            const value = hh + ':' + mm;
            return { id: value, title: value };
        });

        setTimeList(timeList);

    }, []);

    React.useEffect(() => {
        if (formDataInit && typeof formDataInit === 'object') {
            if (formDataInit.date && dateList.find(e => e.id == formDataInit.date)) handleDateChange(formDataInit.date);
            if (formDataInit.time) handleTimeChange(formDataInit.time);
            if (formDataInit.seats) handleSeatsChange(parseInt(formDataInit.seats));
        }
    }, [formDataInit, dateList]);

    return <div className="offer-control__form">
        <div className="offer-control__row">

            <Select
                keyPrefix={'form'}
                items={dateList}
                value={dateValue}
                parentClass={'search-date search-time inputbox'}
                selectClass={"offer-selectbox"}
                dropdownClass={'offer-selectbox-drop'}
                useBodyAsParent={true}
                required={true}
                disabled={dateList.length === 1}
                error={!!errors.date}
                onChange={(value) => handleDateChange(value)} />

            <Select
                keyPrefix={'form'}
                items={timeList}
                value={timeValue}
                parentClass={'search-time inputbox'}
                selectClass={"offer-selectbox"}
                dropdownClass={'offer-selectbox-drop'}
                useBodyAsParent={true}
                required={true}
                error={!!errors.time}
                onChange={(value) => handleTimeChange(value)} />

            <SpinWidget
                className={'search-inputbox search-count'}
                value={seatsValue}
                minValue={1}
                maxValue={maxSeats}
                error={!!errors.seats}
                errorClass={'error_border'}
                onChange={(value) => handleSeatsChange(value)} />
        </div>
    </div>;
}
